import { render, staticRenderFns } from "./CreateTaskForm.vue?vue&type=template&id=0ea24522"
import script from "./CreateTaskForm.vue?vue&type=script&lang=js"
export * from "./CreateTaskForm.vue?vue&type=script&lang=js"
import style0 from "./CreateTaskForm.vue?vue&type=style&index=0&id=0ea24522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports